import {fetchGet, generateEndpoint} from "../../../utils/request";

export type AuditLogRange = 'today' | '7days' | '1month' | '1year' | 'all';

export const getAuditLogs = async(token: string, range: AuditLogRange = 'all') => {
  const url = `${generateEndpoint("getAuditLogs")}?range=${range}`;
  return fetchGet(url, token);
};
